import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { z } from 'zod';
export var errorMessages = {
  minLength: function minLength(length) {
    return "This must be at least ".concat(length, " characters.");
  },
  maxLength: function maxLength(length) {
    return "This must be at most ".concat(length, " characters.");
  },
  required: 'This is a required field.',
  shouldIncludeLowerCase: 'This must contain a lower case character.',
  shouldIncludeUpperCase: 'This must contain an upper case character.',
  shouldIncludeNumber: 'This must contain a number.',
  shouldIncludeSpecialChar: 'This must contain a special character.',
  shouldNotIncludeSpecialChar: 'This must not contain special characters.',
  shouldNotIncludeFirstNameInPassword: 'Password should not include first name.',
  shouldNotIncludeLastNameInPassword: 'Password should not include last name.',
  invalidEmail: 'Please enter a valid email.',
  confirmEmailMismatch: 'The emails do not match.',
  emailAlreadyTaken: 'This email is already in use, try another one or contact recruitersupport@applyboard.com, if you believe this is an error.'
};

// password validation functions
export var lengthGreaterThanX = function lengthGreaterThanX(text, minLength) {
  return text.length >= minLength;
};
export var lengthLessThanX = function lengthLessThanX(text, maxLength) {
  return text.length <= maxLength;
};
export var textContainsLowerCase = function textContainsLowerCase(text) {
  return /[a-z]/.test(text);
};
export var textContainsUpperCase = function textContainsUpperCase(text) {
  return /[A-Z]/.test(text);
};
export var textContainsNumber = function textContainsNumber(text) {
  return /\d/.test(text);
};
export var textContainsSymbol = function textContainsSymbol(text) {
  return /[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/.test(text);
};
export var textDoesNotContainSymbol = function textDoesNotContainSymbol(text) {
  return !textContainsSymbol(text);
};
export var textIncludesSubstr = function textIncludesSubstr(text, substring) {
  if (text && substring) {
    var isSubstrIncluded = text.toLowerCase().includes(substring.toLowerCase());
    if (isSubstrIncluded) return true;
  }
  return false;
};
export var testValidEmail = function testValidEmail(text) {
  return z.string().email().safeParse(text).success;
};

/**
 * the validation function that returns a password error state, used by PasswordRequirements.tsx
 * to display realtime password feedback, and a list of errors, to be displayed below the password
 * field onBlur or during form submission
 */
export var validatePassword = function validatePassword(password, firstName, lastName) {
  var passwordErrorState = {
    required: false,
    minLength: false,
    shouldIncludeLowerCase: false,
    shouldIncludeUpperCase: false,
    shouldIncludeNumber: false,
    shouldIncludeSpecialChar: false,
    shouldNotIncludeFirstNameInPassword: false,
    shouldNotIncludeLastNameInPassword: false
  };
  var passwordErrorMessageList = [];
  if (!lengthGreaterThanX(password, 12)) {
    passwordErrorState.minLength = true;
    passwordErrorMessageList.push(errorMessages.minLength(12));
  }
  if (!textContainsLowerCase(password)) {
    passwordErrorState.shouldIncludeLowerCase = true;
    passwordErrorMessageList.push(errorMessages.shouldIncludeLowerCase);
  }
  if (!textContainsUpperCase(password)) {
    passwordErrorState.shouldIncludeUpperCase = true;
    passwordErrorMessageList.push(errorMessages.shouldIncludeUpperCase);
  }
  if (!textContainsSymbol(password)) {
    passwordErrorState.shouldIncludeSpecialChar = true;
    passwordErrorMessageList.push(errorMessages.shouldIncludeSpecialChar);
  }
  if (!textContainsNumber(password)) {
    passwordErrorState.shouldIncludeNumber = true;
    passwordErrorMessageList.push(errorMessages.shouldIncludeNumber);
  }
  if (textIncludesSubstr(password, firstName)) {
    passwordErrorState.shouldNotIncludeFirstNameInPassword = true;
    passwordErrorMessageList.push(errorMessages.shouldNotIncludeFirstNameInPassword);
  }
  if (textIncludesSubstr(password, lastName)) {
    passwordErrorState.shouldNotIncludeLastNameInPassword = true;
    passwordErrorMessageList.push(errorMessages.shouldNotIncludeLastNameInPassword);
  }
  return {
    passwordErrorState: passwordErrorState,
    passwordErrorMessageList: passwordErrorMessageList
  };
};